import React from 'react';
import {useTranslation} from 'react-i18next';
import {useAppSelector} from '../store';
import {Converter} from 'showdown';
import {
  brandedFooterClassBinding,
  removeSurroundingPElementBinding,
} from '../util/showdownUtils';

const BrandedFooter = () => {
  const {t} = useTranslation();

  const showdownConverter = new Converter({
    extensions: [
      ...brandedFooterClassBinding,
      removeSurroundingPElementBinding,
    ],
    openLinksInNewWindow: true,
  });
  const leftMarkdown = showdownConverter.makeHtml(
    useAppSelector((state) => state.footerLeftMarkdown.value),
  );
  const rightMarkdown = showdownConverter.makeHtml(
    useAppSelector((state) => state.footerRightMarkdown.value),
  );
  return (
    <div className="footer branded-footer" data-testid="app-footer">
      <div className="footer-panel">
        <ul className="footer-list">
          <li dangerouslySetInnerHTML={{__html: leftMarkdown}}></li>
        </ul>
        <ul className="footer-list d-flex flex-row align-items-center">
          <li dangerouslySetInnerHTML={{__html: rightMarkdown}}></li>
        </ul>
      </div>
    </div>
  );
};

export default BrandedFooter;
